import { makeStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  ReadOnlyInputTextFieldRoot: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(0px, -6px) scale(0.75)',
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '& .MuiOutlinedInput-root': {
      '& input': {
        paddingLeft: 0,
        paddingRight: 0,
      },
      '& fieldset': {
        borderColor: 'transparent',
      },
      '&:hover fieldset': {
        borderColor: 'transparent',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent',
      },
    },
    width: '100%',
  },
}));

function ReadOnlyInput({
  id,
  label,
  value,
  touched,
  error,
  onFocus,
  onBlur,
  onChange,
  onKeyDown,
  onKeyPress,
  onKeyUp,
  className,
  InputProps,
}) {
  const classes = useStyles();

  return (
    <TextField
      id={id}
      name={id}
      label={label}
      className={className}
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      InputProps={{
        ...InputProps,
        readOnly: true,
      }}
      classes={{ root: classes.ReadOnlyInputTextFieldRoot }}
      value={value === undefined ? '-' : value}
      error={error && touched}
      helperText={touched && error}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onKeyPress={onKeyPress}
      onKeyUp={onKeyUp}
    />
  );
}

ReadOnlyInput.propTypes = {
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
};

ReadOnlyInput.defaultProps = {
  fullWidth: true,
};

export default ReadOnlyInput;
